import React from 'react'

function PaperPlane() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M14.2075 1.79248C14.0817 1.66682 13.9248 1.57694 13.7527 1.53212C13.5807 1.4873 13.3998 1.48915 13.2287 1.53748H13.2194L1.22312 5.17748C1.02837 5.23361 0.855266 5.34759 0.726756 5.50432C0.598247 5.66105 0.520396 5.85313 0.503519 6.05511C0.486643 6.25708 0.531538 6.45942 0.632255 6.6353C0.732972 6.81119 0.884757 6.95231 1.06749 7.03998L6.37499 9.62498L8.95624 14.9294C9.03653 15.1007 9.16417 15.2455 9.3241 15.3466C9.48402 15.4477 9.66954 15.5009 9.85874 15.5C9.8875 15.5 9.91624 15.4987 9.94499 15.4962C10.1468 15.4799 10.3388 15.4022 10.4952 15.2736C10.6516 15.145 10.7649 14.9717 10.82 14.7769L14.4575 2.78061C14.4575 2.77748 14.4575 2.77436 14.4575 2.77123C14.5065 2.60059 14.5091 2.41998 14.4652 2.24797C14.4212 2.07596 14.3323 1.91875 14.2075 1.79248ZM9.86437 14.4906L9.86124 14.4994V14.495L7.35749 9.35123L10.3575 6.35123C10.4473 6.2567 10.4966 6.13083 10.495 6.00045C10.4933 5.87007 10.4408 5.74549 10.3486 5.65329C10.2564 5.56109 10.1318 5.50856 10.0014 5.50689C9.87103 5.50522 9.74515 5.55455 9.65062 5.64436L6.65062 8.64436L1.50499 6.14061H1.50062H1.50937L13.5 2.49998L9.86437 14.4906Z"
        fill="#3A383F"
      />
    </svg>
  )
}

export default PaperPlane